/*
 * Wicked Clothes — load product images ahead of the scroll (owner, 2026-11-03).
 *
 * Product card images are loading="lazy". iPhone Safari only starts a lazy
 * load when the image is nearly on screen, so a normal scroll shows grey
 * boxes that fill in a beat later. This flips each card's main image to
 * eager once it is within ~1.5 screens of the viewport, so the download is
 * done before it arrives.
 *
 * Covers every product card on any page (collections, homepage rows,
 * recommendations, search) and cards added later (load-more, size filter,
 * recommendations fetched after load). Only the card's first image: the
 * hover-swap second image stays lazy, so phones don't download extra photos.
 * Videos are untouched.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var SEL = '.card__media .media > img:first-child[loading="lazy"]';

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.loading = 'eager';
      io.unobserve(e.target);
    });
  }, { rootMargin: '150% 0px 150% 0px' });

  function scan() {
    document.querySelectorAll(SEL).forEach(function (img) {
      if (img.__wcAhead) return;
      img.__wcAhead = true;
      io.observe(img);
    });
  }

  var queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 100);
  }

  scan();
  new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
})();
